import SubcategoryPageLayout from "@/components/SubcategoryPageLayout";

const subcategories: Record<string, { heading: string; subtitle: string; categoryKey: string }> = {
  "cancelli": { heading: "Cancelli", subtitle: "Ingressi sicuri con design personalizzato su misura.", categoryKey: "ferro-cancelli" },
  "ringhiere": { heading: "Ringhiere e Balconi", subtitle: "Protezione e stile per ogni balconata e scala.", categoryKey: "ferro-ringhiere" },
  "grate": { heading: "Grate di Sicurezza", subtitle: "Inferriate robuste con linee moderne e discrete.", categoryKey: "ferro-grate" },
  "scale": { heading: "Scale", subtitle: "Strutture resistenti in ferro con finiture curate.", categoryKey: "ferro-scale" },
  "recinzioni": { heading: "Recinzioni", subtitle: "Delimitazione della proprietà con eleganza e sicurezza.", categoryKey: "ferro-recinzioni" },
  "balconate": { heading: "Balconate", subtitle: "Dettagli in ferro battuto di pregio artigianale.", categoryKey: "ferro-balconate" },
};

export default subcategories;
